function timeStringToSeconds(timeString) {
  const [hours, minutes, seconds] = timeString.split(':').map(Number);
  return hours * 3600 + minutes * 60 + seconds;
}

// -------------------------------------------------------------------------------
// Component
// -------------------------------------------------------------------------------
export function Tracklist({tracklist, played }) {
    return (
      <div id="tracklist" style={{display: 'grid'}}>
      {tracklist.map((item) => (
          <div
          key={`track_${item.id}`}
          className="tracklist-row"
          style={{
            display: 'flex',
            marginBottom: '10px',
            borderBottom: '1px solid #333333',
            color: timeStringToSeconds(item.time) < played ? '#333333' : '#ffffff',
          }}
        >
        <span className="track" style={{ flex: '35%' }}> {item.track} </span>
        <span className="artist" style={{ flex: '45%' }}> {item.artist} </span>
        <span className="time" style={{ flex: '20%' }}> {item.time} </span>
  </div>
))}
     </div>
    );
}

export default Tracklist;
